import React, { useState } from "react";
import { Link } from "react-router-dom";

//  $$ Images $$ \\
import logo from "../../assets/images/logo.png";
import logoNew from "../../assets/images/LogoNew.png";

//  $$ Style $$ \\
import "../../assets/styles/header/header.scss";

//  $$ React Icon $$ \\
import { BsSearch } from "react-icons/bs";
import { FaRegHeart } from "react-icons/fa6";
import { IoIosBasket } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { SlClose } from "react-icons/sl";

const Header = () => {
  const [active, setActive] = useState(false);

  const navModal = () => {
    console.log("hello");
    return setActive(!active);
  };

  return (
    <div>
      <header>
        <div className="containers">
          <div className="header_items py-4 flex items-center justify-between gap-10">
            <div className="header_items_logo">
              <Link to={"/"} className="logoLink w-44">
                <img src={logo} className="" alt="logo" />
              </Link>
            </div>

            <div className=" gap-14 flex">
              <div className="header_items_navbar flex gap-10">
                <ul className="ul flex gap-12 mt-2">
                  <li>
                    <Link to={"/"} className="NavbarLink">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to={"/aboutUs"} className="NavbarLink">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to={"/products"} className="NavbarLink">
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link to={"/service"} className="NavbarLink">
                      Service
                    </Link>
                  </li>
                  {/* <li>
                    <Link to={"/contact"} className="NavbarLink">
                      Contact
                    </Link>
                  </li> */}
                  <li>
                    <Link to={"/product_colculation"} className="NavbarLink">
                      Product calculation
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="header_items_contact mt-2 gap-4 flex items-center">
              <Link className="iconsLink flex items-center gap-3">
                <FaRegHeart className="icons  text-2xl text-red-700" />
                <IoIosBasket className="icons text-2xl text-stone-700" />
              </Link>

              <Link to={"/contact"} className="contactLink">
                Contact
              </Link>
              <div className="burger">
                <GiHamburgerMenu onClick={navModal} className="burgerIcons" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-control">
          <div className="containers">
            <form className="bg">
              <span className="flex items-center gap-24">
                <BsSearch className="searchIcon text-4xl text-white" />
                <input
                  className="search w-full"
                  type="text"
                  placeholder="Search"
                />
              </span>
            </form>
          </div>
        </div>

        {/* Modal */}

        <div className={`modalNav ${active ? "active" : ""}`}>
          <div className="modalNav_items">
            <div className="head flex justify-between items-center">
              <div className="logo">
                <Link to={"/"}>
                  <img src={logoNew} alt="" />
                </Link>
              </div>
              <div className="close_box">
                <SlClose className="closeIcons" onClick={navModal} />
              </div>
            </div>

            <div className="nav_box">
              <ul className="ul flex gap-12 mt-2">
                <li>
                  <Link to={"/"} className="NavbarLink" onClick={navModal}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/aboutUs"}
                    className="NavbarLink"
                    onClick={navModal}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/products"}
                    className="NavbarLink"
                    onClick={navModal}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/service"}
                    className="NavbarLink"
                    onClick={navModal}
                  >
                    Service
                  </Link>
                </li>
                {/* <li>
                    <Link to={"/contact"} className="NavbarLink">
                      Contact
                    </Link>
                  </li> */}
                <li>
                  <Link
                    to={"/product_colculation"}
                    className="NavbarLink"
                    onClick={navModal}
                  >
                    Product calculation
                  </Link>
                </li>
              </ul>

              <Link to={"/contact"} className="contactLink" onClick={navModal}>
                Contact
              </Link>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
